<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="w-full lg:w-1/3 pb-8 pr-6">
          <search-input v-model="search" class="w-full" />
        </div>
        <div class="w-full lg:w-2/3 pb-8 pr-6 flex justify-end">
          <Link class="btn-indigo" :href="route('employees.create')">
            <span>{{ __('Create') }}</span>
            <span class="hidden md:inline">&nbsp;{{ __('Employee') }}</span>
          </Link>
        </div>
      </div>
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">{{ __('Name') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('Email') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('Phone') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('City') }}</th>
          <th class="pb-4 pt-6 px-6">{{ __('Country') }}</th>
          <th class="pb-4 pt-6 px-6" colspan="2">{{ __('Created') }}</th>
        </tr>
        <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="route('employees.edit', user.id)">
              <img v-if="user.photo" class="block w-5 h-5 rounded-full mr-2" :src="user.photo" />
              {{ user.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('employees.edit', user.id)" tabindex="-1">
              {{ user.email }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('employees.edit', user.id)" tabindex="-1">
              {{ user.phone }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('employees.edit', user.id)" tabindex="-1">
              {{ user.city }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('employees.edit', user.id)" tabindex="-1">
              {{ user.country }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('employees.edit', user.id)" tabindex="-1">
              {{ user.created_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="route('employees.edit', user.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">{{ __('No employees found.') }}</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import SearchInput from '@/Shared/SearchInput'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    Layout,
    SearchInput,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    title: String,
  },
  data() {
    return {
      search: this.filters.search,
    }
  },
  watch: {
    search(value) {
      this.$inertia.get(this.route('employees'), { search: value }, { preserveState: true })
    },
  },
}
</script>
